import { TableColumProps } from "@/components/molecules/Table";
import { fakeI18n } from "@/i18n";
import { InsuredGood, InsuredGoodSortProperty } from "@/shared/domain";

export const insuredGoodTableColumns: TableColumProps<InsuredGood, InsuredGoodSortProperty>[] = [
    {
        sortableKey: "type.id",
        label: fakeI18n.t("Common.Type"),
        width: 31,
    },
    {
        sortableKey: "name",
        label: fakeI18n.t("Common.Description"),
        width: 56,
    },
    {
        unsortableKey: "relatedContracts.reference",
        label: "",
        notSortable: true,
        width: 14,
    },
];
